// Module
var code = `<md-sidenav class="md-sidenav-right md-whiteframe-z1" md-component-id="sidenav-right" md-is-locked-open="\$mdMedia('gt-md') && \$state.\$current.includes.companyDetails"> <ui-view name="sidenav-right" class="animate-ui" layout="column" flex></ui-view> </md-sidenav>`;
// Exports
module.exports = code;